import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Alert, Form, FormControl, FormGroup } from 'react-bootstrap-5';

import { Button } from 'components/ui/button';
import { createShowcaseContact } from './api';

function ShowcaseContactForm({ onAddContact }) {
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const renderInput = (label, fieldKey, required = false) => {
    const fieldId = `showcase-contact-${fieldKey}`;
    return (
      <FormGroup className="mb-3">
        <Form.Label className="fw-semibold" htmlFor={fieldId}>
          {label}
          {required && <abbr className="text-destructive ms-1" title="required">*</abbr>}
        </Form.Label>
        <FormControl
          id={fieldId}
          placeholder={label}
          required={required}
          value={formData[fieldKey] || ''}
          onChange={e => setFormData({ ...formData, [fieldKey]: e.target.value })}
        />
      </FormGroup>
    );
  };

  const paramValue = (param, fallback = null) => {
    const value = param?.trim();
    return value || fallback;
  };

  const createParams = () => ({
    firstName: paramValue(formData.firstName, ''),
    lastName: paramValue(formData.lastName, ''),
    email: paramValue(formData.email),
    jobTitle: paramValue(formData.jobTitle),
    licenseNumber: paramValue(formData.licenseNumber)
  });

  const handleSubmit = () => {
    setSaving(true);

    createShowcaseContact(createParams()).then((data) => {
      onAddContact(data);
    }).catch(setErrors).finally(() => setSaving(false));
  };

  return (
    <>
      {errors.length > 0 && (
        <Alert className="text-start" variant="danger">
          <div><strong>Whoops -</strong> There were errors in the form that prevented saving.</div>
          <ul className="m-0">
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}

      {renderInput('First Name', 'firstName', true)}
      {renderInput('Last Name', 'lastName', true)}
      {renderInput('Email', 'email')}
      {renderInput('Job Title', 'jobTitle')}
      {renderInput('License Number', 'licenseNumber')}

      <div className="text-end mt-4">
        <Button disabled={saving} label="Create or Save" onClick={handleSubmit} />
      </div>
    </>
  );
}

ShowcaseContactForm.propTypes = {
  onAddContact: PropTypes.func.isRequired
};

export default ShowcaseContactForm;
